import { Injectable } from '@angular/core';
import { CanLoad, Router } from '@angular/router';
import { AuthenticationService } from '../authentication/authentication.service';
import { NavigationService } from '@core/services/native/navigation.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanLoad {

  constructor(
    private authenticationService: AuthenticationService,
    private navigationService: NavigationService
  ) {

  }

  canLoad(): boolean {
    if (!this.authenticationService.isAuthenticated.value) {
      this.navigationService.navigate(['login'], null, { replaceUrl: true });
      return false;
    }

    return true;
  }
}
